import { render } from "./trueOrFalseQuestion.vue?vue&type=template&id=05e6bdce&scoped=true"
import script from "./trueOrFalseQuestion.vue?vue&type=script&lang=js"
export * from "./trueOrFalseQuestion.vue?vue&type=script&lang=js"

import "./trueOrFalseQuestion.vue?vue&type=style&index=0&id=05e6bdce&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e6bdce"]])

export default __exports__